module.exports = "/images/mt.svg?3e472ec65358ecddddbe255a4269203f";